import Vue from 'vue';
import Vuex from 'vuex';
import { getPromoDetail, getPromoRecommendations, getPromoMerchants, getPromoStoresByMerchant } from '@/actions/index';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    promoDetail: [],
    promoRecommendations: [],
    promoMerchants: [],
    promoStoresByMerchant: [],
    promoStoresEnd: false,
    activeCategory: 'Semua',
    renderLoader: false,
    pageError: {
      type: '',
      status: false,
    },
  },
  getters: {
    getPromoDetail: state => state.promoDetail,
    getPromoMerchants: state => state.promoMerchants,
    getPromoStoresByMerchants: state => state.promoStoresByMerchant,
    getPromoStoresEnd: state => state.promoStoresEnd,
    getPromoRecommendations: state => state.promoRecommendations,
    getActiveCategory: state => state.activeCategory,
    getPageError: state => state.pageError,
    getRenderLoader: state => state.renderLoader,
  },
  actions: {
    updateActiveCategory({ commit }, value) {
      commit('updateActiveCategory', value);
    },

    async getPromoRecommendations({ commit }, params) {
      commit('setLoader', true);
      try {
        const { data } = await getPromoRecommendations(params);
        commit('setPromoRecommendations', data);
        if (this.getters.getPromoRecommendations.length === 0) {
          commit('setError', true);
          commit('setErrorType', 'emptyError');
        } else {
          commit('setError', false);
        }
        commit('setLoader', false);
      } catch (err) {
        commit('setPromoRecommendations', []);
        if (err.message !== 'Operation canceled due to new request.') {
          commit('setError', true);
          commit('setErrorType', 'networkError');
          commit('setLoader', false);
        } else {
          commit('setLoader', true);
        }
      }
    },

    async getPromoDetail({ commit }, id) {
      commit('setLoader', true);
      try {
        const { data } = await getPromoDetail(id);
        commit('setPromoDetail', data);
        commit('setError', false);
      } catch (err) {
        commit('setPromoDetail', []);
        commit('setError', true);
        commit('setErrorType', 'networkError');
      }
      commit('setLoader', false);
    },

    async getPromoMerchants({ commit }, id) {
      commit('setLoader', true);
      try {
        const { data } = await getPromoMerchants(id);
        commit('setPromoMerchants', data);
      } catch (err) {
        commit('setPromoMerchants', []);
        commit('setError', true);
        commit('setErrorType', 'networkError');
      }
      commit('setLoader', false);
    },

    async getPromoStoresByMerchant({ state, commit }, {firstLoad = false, payload}) {
      commit('setLoader', true);
      try {
        const { data } = await getPromoStoresByMerchant(payload);
        if (firstLoad) {
          commit('setPromoStoresByMerchant', data.data);
          commit('setPromoStoresEnd', false);
        } else {
          commit('setPromoStoresByMerchant', [...state.promoStoresByMerchant, ...data.data]);
          if (data.data.length === 0 && payload.page !== 0) {
            commit('setPromoStoresEnd', true);
          }
        }
      } catch (err) {
        if (err.response?.data?.status === 404 && err.response?.data?.message === 'Stores not found' && payload.page !== 0) {
          commit('setPromoStoresEnd', true);
          return;
        }
        commit('setPromoStoresByMerchant', []);
        commit('setError', true);
        commit('setErrorType', 'networkError');
      } finally {
        commit('setLoader', false);
      }
    },

    setLoader({ commit }, value) {
      commit('setLoader', value);
    },
    setError({ commit }, value) {
      commit('setError', value);
    },
    setErrorType({ commit }, value) {
      commit('setErrorType', value);
    },
  },
  mutations: {
    updateActiveCategory(state, value) {
      state.activeCategory = value;
    },
    setLoader(state, value) {
      state.renderLoader = value;
    },
    setError(state, value) {
      state.pageError.status = value;
    },
    setErrorType(state, value) {
      state.pageError.type = value;
    },
    setPromoRecommendations(state, value) {
      state.promoRecommendations = !value.data ? value : value.data.components[0].components;
    },
    setPromoDetail(state, value) {
      state.promoDetail = value.data;
    },
    setPromoMerchants(state, value) {
      state.promoMerchants = value.data;
    },
    setPromoStoresByMerchant(state, value) {
      state.promoStoresByMerchant = value;
    },
    setPromoStoresEnd(state, value) {
      state.promoStoresEnd = value;
    },
  },
  modules: {},
});
